import { render, staticRenderFns } from "./CreateTargetOffers.vue?vue&type=template&id=2ca9f9d9"
import script from "./CreateTargetOffers.vue?vue&type=script&lang=js"
export * from "./CreateTargetOffers.vue?vue&type=script&lang=js"
import style0 from "./CreateTargetOffers.vue?vue&type=style&index=0&id=2ca9f9d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports